export const popupHeaderStyleOverrides = {
  container: { pl: '42px', pt: '49px' },
}

export const popupBodyStyleOverrides = {
  pt: '16px',
  pl: '42px',
  pr: '41.15px',
  pb: '0',
}
